















import Vue from 'vue';
import Validation from '../../mixins/validation';

export default Vue.extend({
	name: 'FieldPhone', 
	props: {
		value: String, 
		name: String, 
		label: String, 
		required: Boolean, 
		validateNow: Boolean
	},
	data: function(){
		return {
			form: {
				phoneNumber: {
					isValid: false, 
					value: '', 
					isDirty: false
				}
			}
		};
	},
	computed: {
		isMobile(): boolean {
			return 0 == this.form.phoneNumber.value.indexOf('04');
		},
		phoneNumberRules(): Array<Function> {
			return this.required ? [Validation.isFormattedPhoneNumber] : [(v: string) => true];
		}, 
		phoneHint(): string {
			const land: Array<string> = ['02', '03', '07', '08'];
			const hasArea: boolean = this.form.phoneNumber.value.length >= 2 && land.includes(this.form.phoneNumber.value.substring(0, 2));
			return !this.isMobile && !hasArea ? 'Please include area code' : '';
		}
	},
	methods: {
		handleFieldInput(): void {
			this.form.phoneNumber.isDirty = true;
			this.setFieldValid(this.form.phoneNumber, this.phoneNumberRules);
			this.$emit('input', this.form.phoneNumber.isValid ? this.form.phoneNumber.value : '');
		},
		setFieldValid(o: any, r: Array<Function>): void {
			o.isValid = Validation.isFieldValid(o.value, r);
		}, 
		handlePhoneKeyup(e: any): void {
			const v = this.form.phoneNumber.value.replace(/\s/g, '').substring(0, 10);
			let num;
			if (this.isMobile){
				num = v.replace(/(\d{4})/, '$1 ');
				num = num.replace(/(\s+\d{3})/, '$1 ');
			}
			else {
				num = v.replace(/(\d{2})/, '$1 ');
				num = num.replace(/(\s+\d{4})/, '$1 ');
			}
			this.form.phoneNumber.value = num.trim();
			if (typeof e != 'boolean' || (typeof e == 'boolean' && e)){
				(!v.length || v.length == 10) && this.handlePhoneBlur();
			}
		},
		handlePhoneBlur(): void {
			this.$emit('blur', Validation.isFormattedPhoneNumber(this.form.phoneNumber.value));
		}
	}, 
	mounted(){
		if (this.value){
			this.form.phoneNumber.value = this.value;
			this.form.phoneNumber.isValid = true;
			this.form.phoneNumber.isDirty = true;
		}
		this.handlePhoneKeyup(false);
	}
});
